/*产品展示item*/
import { getCatlogsAction } from '@ivymobi/orbit-core/business/productCenter';
import _, { filter, union } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TenantContext, UserContext } from '../../orbit-context';
import { Loading } from '../../components';
import { Box, IconButton } from '@mui/material';
import './productItem.css';
import { MoreHoriz } from '@mui/icons-material';
const getImageUrl = (item,defalut)=>{
  if( item.mime&&(item.mime.length>0)){
    let items = filter(item.mime, {mimePurpose: 'thumbnail'});
    if(items.length>0){
     let img =  _.get(items[0],"['mimeSource'][0]['#text']");
     return img.length>0?img:defalut;
    }
  }

  return defalut;
}
const ProductItem = (props) => {
    
  const {item, setSelectInfo, itype} = props;
  const _item = {name:'', imgUrl:''};
  if (item.type ==='catalog') {
    _item.name = item.cgName?.zh;
    _item.imgUrl = getImageUrl(item,'/images/catlog.svg');
  } else if (item.type==='product') {
    _item.name = item.details?.descriptionShort?.zh;
    _item.imgUrl =getImageUrl(item,'/images/dproduct.svg');
  }
  return (
    <Box className="productItemPd">   
      <Box className="productItem"  >   
        <Box onClick={() => {props.onClick(item.id, _item.name, item.type, item.csName);}} style={{ cursor:'pointer',display:'flex', justifyContent:'center', alignItems:'center', flexGrow:1,height:'0px', width:'100%'}}>
          <img src={_item.imgUrl}  style={{objectFit:'contain', padding:'0px', height :'100%',width:'100%'}}></img>
        </Box>

        
        {((itype!='share'))&&((window.parent.length != 0)||window.WeixinJSBridge) && <Box style={{width:'100%',height:'30px', display:'flex', justifyContent:'flex-end'}}>
          <IconButton
            onClick={(e) => {

              setSelectInfo({show:true, item:item, target:e.target});
            }}
            size="large">
            <MoreHoriz />
          </IconButton>
        </Box>}
        <Box style={{background:'#f2f2f2',display:'flex',justifyContent:'center',alignItems:'center',width:'100%'}}>
          <Box  style={{visibility:_item.name?'visible':'hidden' ,paddingLeft:'10rpx', width:'100%', maxHeight:'35px', whiteSpace:'pre-line', textOverflow:'ellipsis', overflow:'hidden'}}>
            <Box style={{paddingTop:'4px',paddingBottom:'4px',paddingRight:'4px',paddingLeft:'10px',fontSize:'14px', whiteSpace:'nowrap', textOverflow:'ellipsis', overflow:'hidden'}}>{_item.name?_item.name:'占位'}</Box>
          </Box>
        </Box>

      </Box>
       
    </Box>
  ); 
};

export default ProductItem;